const util = {
    getTopicDetail(id){
        return new Promise((resolve, reject)=>{
            Util.ajax.get(Util.api.rec_award_topic_detail, {
                params: {id: id}
            }).then((response)=>{
                return response.data;
            }).then((res)=>{
                if(res.code === 1){
                    resolve(res.data);
                }else{
                    reject({message: res.msg});
                }
            }).catch((e)=>{
                reject(e);
            });
        });
    }
};


util.new_record = {
    team_id: 0,
    referrer_id: 0,
    referrer_account: '',
    referee_id: 0,
    referee_account: '',
    bank_type: '',
    bank_number: '',
    total_award: 500,
};
util.new_topic = {
    name: '',
    apply_user_id: 0,
    apply_user: '',
    delivery_month: '',
    company_id: 0,
    total_price: 0,
    rec_award_records: [util.new_record]
};


export default util;
